import { OrderEntryGoogleAnalyticV4 } from '@analytics/const';
import { Injectable } from '@angular/core';
import { OrderEntry } from '@spartacus/core';
import { AnalyticsService } from './analytics.service';

const mapOrderEntries = (entries: OrderEntry[]): OrderEntryGoogleAnalyticV4[] => {
  return entries?.map((entry: OrderEntry) => ({
    item_id: entry.product.code,
    item_name: entry.product.name,
    price: entry.basePrice.value,
    quantity: entry.quantity,
  }));
};

// Аналитика чекаута для гугл аналитики версии 4
@Injectable({ providedIn: 'root' })
export class CheckoutAnalyticsGaV4Service {
  constructor(private analyticsService: AnalyticsService) {}

  onGoToNonEmptyCartPage(entries: OrderEntry[]): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'view_cart',
      ecommerce: {
        items: mapOrderEntries(entries),
      },
    });
  }

  onGoToCheckoutPage(entries: OrderEntry[]): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'begin_checkout',
      ecommerce: {
        items: mapOrderEntries(entries),
      },
    });
  }

  onSetRetrievalMethod(entries: OrderEntry[], retrievalMethod: string): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'add_shipping_info',
      ecommerce: {
        shipping_tier: retrievalMethod,
        items: mapOrderEntries(entries),
      },
    });
  }

  onSetPayment(entries: OrderEntry[], paymentType: string): void {
    this.analyticsService.sendEcommerceEvent({
      event: 'add_payment_info',
      ecommerce: {
        payment_type: paymentType,
        items: mapOrderEntries(entries),
      },
    });
  }
}
